import React from 'react';
import './Textarea.scss';

export type TextareaProps = {
    placeholder: string;
    value: string;
    onValueChange: React.Dispatch<React.SetStateAction<string>> | ((value: string) => void);
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea: React.FC<TextareaProps> = ({ placeholder, value, onValueChange, ...props }) => {
    return (
        <div className="textarea-container">
            <textarea placeholder={placeholder} value={value} onChange={(e) => onValueChange(e.target.value)} {...props} />
        </div>
    );
};
